/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * this is the schema for the object entites
 */
export interface Entity { 
    id?: number;
    name?: string;
    navigation?: string;
    tables?: string;
}

